import React, { useState } from 'react';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import { useNotification } from '@adsk/bim360-matrix-react-notification-manager/es/helpers/context';
import {
  NotificationLevels,
  NotificationTypes
} from '@adsk/bim360-matrix-react-notification-manager/es/helpers/consts';
import TryAgainNotificationMessage from '../../TryAgainNotificationMessage';

export default (onRemove, onRemoveSuccess) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`../../i18n/${locale}.json`)));
  const { showNotification } = useNotification();
  const [isRemoving, setIsRemoving] = useState(false);
  const [relationToConfirmRemoving, setRelationToConfirmRemoving] = useState(null);
  const closeConfirmRemoveModal = () => setRelationToConfirmRemoving(null);
  const handleRemoveConfirm = () => {
    setIsRemoving(true);
    onRemove(relationToConfirmRemoving.relationship)
      .then(() => {
        onRemoveSuccess(relationToConfirmRemoving.relationship.id);
        closeConfirmRemoveModal();
        setIsRemoving(false);
      })
      .catch(error => {
        console.error('Error removing relationship', error);
        showNotification({
          type: NotificationTypes.SNACKBAR,
          level: NotificationLevels.ERROR,
          message: (
            <TryAgainNotificationMessage onTryAgain={handleRemoveConfirm}>
              {T.translate('ERROR_REMOVING_RELATIONSHIPS_MESSAGE')}
            </TryAgainNotificationMessage>
          )
        });
        setIsRemoving(false);
      });
  };
  return {
    relationToConfirmRemoving,
    setRelationToConfirmRemoving,
    isRemoving,
    closeConfirmRemoveModal,
    handleRemoveConfirm
  };
};
